export default __webpack_public_path__ + "static/media/DaikinFCU.c69f5065.png";